import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function useRestauranteMesa(mesaId) {
  const [operacion, setOperacion] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  const cargar = useCallback(async () => {
    if (!mesaId) return;

    setCargando(true);
    setError('');

    try {
      const response = await api.get(
        `/restaurante/mesas/${mesaId}/operacion`
      );

      setOperacion(response.data || null);
    } catch (err) {
      console.error('Error cargando operación de mesa:', err);

      setError(
        err?.response?.data?.error ||
          'No se pudo cargar la mesa.'
      );
    } finally {
      setCargando(false);
    }
  }, [mesaId]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  return {
    operacion,
    cargando,
    error,
    recargar: cargar,
  };
}
